import api from '../api';
import { addCompanyIdToRequest } from '../../utils/companyContext';

export async function getSummary(startDate = null, endDate = null) {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const paramsWithCompany = addCompanyIdToRequest(params, 'GET');

  const response = await api.get('/api/dashboard/summary', {
    params: paramsWithCompany,
    headers: {
      auth: true
    }
  });

  return response;
}

export async function getSalesReport(startDate = null, endDate = null) {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const paramsWithCompany = addCompanyIdToRequest(params, 'GET');

  const response = await api.get('/api/dashboard/sales-report', {
    params: paramsWithCompany,
    headers: {
      auth: true
    }
  });

  return response;
}

export async function getTopProducts(limit = 10, startDate = null, endDate = null) {
  const params = { limit };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const paramsWithCompany = addCompanyIdToRequest(params, 'GET');

  const response = await api.get('/api/dashboard/top-products', {
    params: paramsWithCompany,
    headers: {
      auth: true
    }
  });

  return response;
}




